/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Archon_Rounds_ImportedInputs */



/**
* | output |
* | --- |
* | "{count} rounds imported" |
*
* @param {Archon_Rounds_ImportedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_rounds_imported = /** @type {((inputs: Archon_Rounds_ImportedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Rounds_ImportedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} rondes importées`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} rondas importadas`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} rodadas importadas`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} round importati`)
	return /** @type {LocalizedString} */ (`${i?.count} rounds imported`)
});